import Swiper, {Pagination, Navigation, A11y, Lazy, Manipulation} from 'swiper';
import {DateTime} from "luxon";

const SERVICE_ID = 2;
let swiper;

let isMobile = false;

if (window.innerWidth < 992) {
    isMobile = true;
}

const localTimezone = DateTime.local().zoneName;

export function getLocalTimezone() {
    return localTimezone;
}

export function setupWidgetOnline() {
    initSlider();

    const usersId = Array.from(document.querySelectorAll('.widget-online-card'))
        .map(card => {
            card.parentNode.querySelector('.widget-online-book').classList.add('disabled');
            card.parentNode.querySelector('.widget-online-info').classList.add('widget-online-loading');
            card.parentNode.querySelector('.loading-ring').style.display = "inline-block";

            return parseInt(card.dataset.userId)
        });

    parseSlots(usersId);
}

function initSlider() {
    swiper = new Swiper('.widget-online-slider', {
        speed: 300,
        modules: [Navigation, Pagination, A11y, Lazy, Manipulation],
        slidesPerView: 1.4,
        centeredSlides: true,
        centeredSlidesBounds: true,

        preloadImages: false,
        lazy: {
            checkInView: true,
            loadPrevNext: true,
        },
        watchSlidesProgress: true,

        navigation: {
            nextEl: '.widget-online-button.next',
            prevEl: '.widget-online-button.prev',
        },
        pagination: {
            el: '.widget-online-pagination',
            type: 'bullets',
            clickable: true,
        },
        a11y: {
            notificationClass: 'sr-only',
        },
        breakpoints: {
            520: {
                slidesPerView: 2
            },
            630: {
                slidesPerView: 3
            },
            768: {
                slidesPerView: 1,
            }
        },
        grabCursor: true,
        watchOverflow: true,
        spaceBetween: 25,
        slidesPerColumnFill: 'row',
    });

    document.querySelectorAll('.widget-online-button').forEach(element => {
        element.addEventListener('click', () => { element.blur(); });
    });
}

function enoughHours(countTotal)
{
    if (countTotal >= 10) {
        return true;
    }

    return isMobile && countTotal >= 4;
}

function parseSlots(expertIds)
{
    let widgetContainer = document.querySelector('.widget-online-slider');

    let serviceId = SERVICE_ID;
    if (widgetContainer && widgetContainer.dataset.serviceId) {
        serviceId = parseInt(widgetContainer.dataset.serviceId);
    }

    fetchSlots(expertIds, serviceId, slots => {
        document.querySelectorAll('.widget-online-card').forEach((card, cardIndex) => {
            const userId = parseInt(card.dataset.userId);
            let days = {};
            let countTotal = 0;

            for (let day in slots) {
                for (let hour in slots[day]) {
                    if (-1 === slots[day][hour].findIndex(el => userId === el[0])) {
                        continue;
                    }

                    if (day in days) {
                        days[day].push(hour);
                    } else {
                        days[day] = [hour];
                    }
                    countTotal += 1;

                    if (enoughHours(countTotal)) {
                        break;
                    }
                }
                if (countTotal % 2 === 1) {
                    countTotal += 1;
                }
                if (enoughHours(countTotal)) {
                    break;
                }
            }

            if (0 === countTotal) {
                const removeSlide = parseInt(document.querySelector(`.widget-online-card[data-user-id="${userId}"]`).dataset.removeSlide) === 1;
                if (removeSlide) {
                    swiper.removeSlide(cardIndex);
                } else {
                    showEmptySlots(userId);
                }
                return;
            }
            parseWidgetData(userId, days, serviceId);
        });
    });
}

export function fetchSlots(userIds, serviceId, callback) {
    const params = {
        action: 'wpamelia_api',
        call: '/slots',
        serviceId: serviceId,
        providerIds: userIds,
        group: 1,
        page: 'booking',
        person: 1,
        extras: '',
    };
    const urlParams = encodeQueryData(params);

    fetch("/wp-admin/admin-ajax.php?" + urlParams)
        .then(response => {
            if (response.status !== 200) {
                throw new Error("HTTP status " + response.status);
            }
            return response.json();
        })
        .then(data => {
            if ('data' in data) {
                let slots = data.data.slots;
                callback(slots, serviceId);
            }
        });
}
function encodeQueryData(data)
{
    const ret = [];
    for (let d in data) {
        if (Array.isArray(data[d])) {
            for (let el of data[d]) {
                ret.push(d + '[]=' + el);
            }
        } else {
            ret.push(d + '=' + data[d]);
        }
    }
    return ret.join('&');
}

function showEmptySlots(userId) {
    let cardParent = document.querySelector(`.widget-online-card[data-user-id="${userId}"]`).parentNode;
    if (!cardParent) {
        return;
    }

    cardParent.querySelector('.widget-online-info').classList.remove('widget-online-loading');
    cardParent.querySelector('.loading-ring').style.display = "none";
    cardParent.querySelector('.widget-online-info-dates').innerHTML = `
        <div class="widget-online-info-dates-empty">
            <span class="font-weight-bold">Brak wolnych terminów</span>
        </div>
    `;
    let divGrow = document.createElement("div");
    divGrow.classList.add('flex-grow-1');
    cardParent.querySelector('.widget-online-info-dates').after(divGrow);
    cardParent.querySelector('.widget-online-book').classList.add('d-none');
    cardParent.querySelector('.widget-online-profile').classList.remove('d-none');
}

function parseWidgetData(expertId, slots, serviceId)
{
    let card = document.querySelector(`.widget-online-card[data-user-id="${expertId}"]`).parentNode;
    let href = card.querySelector('.user-template').dataset.src;

    let entrypoint = document.querySelector(`.widget-online-card[data-user-id="${expertId}"]`).dataset.ep || 'vuqsg1';

    let userData = {
        id: expertId,
        name: card.querySelector('.user-template .user-template-text-title').dataset.userName,
        thumbnail: card.querySelector('.user-template .user-template-image img').getAttribute('src'),
        price: card.querySelector('.widget-online-card').dataset.userPrice,
        slug: href.substring(href.lastIndexOf('/') + 1),
        location: card.querySelector('.widget-online-card').dataset.userLocation,
    };

    card.querySelector('.widget-online-info-dates').innerHTML = '';

    let localSlots = {};

    for (const ameliaDay in slots) {
        for (const hour of slots[ameliaDay]) {
            let date = DateTime.fromFormat(
                `${ameliaDay} ${hour} Europe/Warsaw`,
                "yyyy-MM-dd HH:mm z"
            ).setZone(getLocalTimezone());

            const day = date.toFormat('y-LL-dd');
            if (!(day in localSlots)) {
                localSlots[day] = [];
            }
            localSlots[day].push(date.toFormat('HH:mm'));
        }
    }

    for (let day in localSlots) {
        let dayHours = localSlots[day].length;
        let date = DateTime.fromFormat(
            day,
            "yyyy-MM-dd"
        ).setLocale('pl');

        let container = card.querySelector('.widget-online-info-dates-template').content
            .querySelector('.widget-online-info-dynamic').cloneNode(true);

        container.style.width = ((dayHours + (dayHours % 2)) / 2 * 20) + '%';
        if (isMobile) {
            container.style.width = '100%';
            container.style.maxWidth = '174px';
        }

        container.querySelector('.widget-online-info-dynamic-date-name').innerHTML = date.toFormat('d LLLL').replace(' ', '<br>');

        for (let hr = 0; hr < dayHours; hr++) {
            let hour = localSlots[day][hr];

            let timeDiv = container.querySelector('.widget-online-hours-item-template').content
                .querySelector('.widget-online-hours-item').cloneNode(true);

            timeDiv.style.width = 1 / ((dayHours + (dayHours % 2)) / 2) * 100 + "%";

            if (Math.ceil(dayHours / 2) > hr) {
                timeDiv.classList.add('mb-2');
            }

            let date = DateTime.fromFormat(
                day + ' ' + hour,
                "yyyy-MM-dd HH:mm"
            ).setLocale('pl').setZone('Europe/Warsaw');

            let linkDate = date.toFormat('yyyy-LL-dd+HH:mm:\'00\'');

            timeDiv.title = "Zarezerwuj wizytę na godzinę " + hour;
            timeDiv.dataset.time = hour;
            timeDiv.innerHTML = '<span class="py-2">' + hour + '</span>';
            timeDiv.href = '/umow-wizyte/' + userData.slug + '?serviceId=' + serviceId
                + '&date=' + linkDate + '&ep=' + entrypoint;

            container.querySelector('.widget-online-hours').appendChild(timeDiv);
        }
        card.querySelector('.widget-online-info-dates').appendChild(container);

        if (isMobile) {
            break;
        }
    }

    card.querySelector('.widget-online-book').classList.remove('disabled');
    card.querySelector('.widget-online-info').classList.remove('widget-online-loading');
    card.querySelector('.loading-ring').style.display = "none";

}
